import React, { useEffect, useMemo, useRef } from 'react';
import { UIGameActionButton } from '../../../../common/UIGameActionButton/index.ts';
import { UIGameResourceCardsTooltipContent } from '../../../../common/UIGameResourceCardsTooltipContent/index.ts';
import { useActionButtonCommonErrors } from '../../utils.ts';
import { T, Tooltip } from '@colonist/ui';
import { ActionState, CardEnum } from '@colonist/game-states';
import { useGameStore } from '../../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../../store/selectors/usePlayerValidators.ts';
import { MapValidator, MechanicValidatorKnightPlayer } from '@colonist/game-mechanic-validators';
import { KNIGHT_ACTIVATION_IMAGE_PATH } from '../../../../utils/gamePieces.ts';
import { useCurrentStateValidator } from '../../../../store/selectors/useCurrentStateValidator.ts';
const cardToActivateKnight = [
    CardEnum.Grain
];
export const UIGameActionButtonKnightActivation = ({ className, onDisabledChange })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const mechanicKnightState = useGameStore((state)=>state.gameState.mechanicKnightState);
    const mapState = useGameStore((state)=>state.gameState.mapState);
    const currentStateValidator = useCurrentStateValidator();
    const { getPlayerValidator, playerValidators } = usePlayerValidators();
    const playerValidator = getPlayerValidator(myColor);
    const tooltipRef = useRef(null);
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const { sendActivateKnight, sendCancelAction, sendClearCornerHighlight } = useGameStore((state)=>state.gameSendEvent);
    const { actionStatus, knightsEligibleForActivationCount } = useMemo(()=>{
        const knightPlayerState = mechanicKnightState === null || mechanicKnightState === void 0 ? void 0 : mechanicKnightState[myColor];
        if (!knightPlayerState) {
            return {
                actionStatus: {
                    canTakeAction: false
                },
                knightsEligibleForActivationCount: 0
            };
        }
        const knightPlayerValidator = new MechanicValidatorKnightPlayer(playerValidator, new MapValidator(mapState), knightPlayerState);
        const knightsEligibleForActivationCountLocal = knightPlayerValidator.getAmountOfKnightsEligibleForActivation();
        const canActivateKnightActionStatus = knightPlayerValidator.canPlayerActivateKnight();
        return {
            actionStatus: canActivateKnightActionStatus,
            knightsEligibleForActivationCount: knightsEligibleForActivationCountLocal
        };
    }, [
        playerValidators,
        mapState,
        mechanicKnightState,
        myColor
    ]);
    const triggerFlickerCardsAnimation = ()=>{
        const notEnoughResources = !playerValidator.hasResourceCardsInHand(cardToActivateKnight);
        if (notEnoughResources) {
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.triggerFlickerAnimation();
        }
    };
    const disabled = hasCommonErrors || !actionStatus.canTakeAction;
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isActivatingKnight = actionState === ActionState.ActivateKnight && !disabled;
    const icon = KNIGHT_ACTIVATION_IMAGE_PATH[myColor];
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    useEffect(()=>{
        onDisabledChange(disabled);
    }, [
        disabled
    ]);
    const onClick = ()=>{
        if (disabled) return;
        if (isActivatingKnight) {
            sendClearCornerHighlight();
            sendCancelAction();
        } else {
            sendActivateKnight();
        }
    };
    return /*#__PURE__*/ React.createElement(Tooltip, {
        position: "bottom",
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.activateKnight"
        })
    }, /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: className,
        count: knightsEligibleForActivationCount,
        countColor: myColor,
        disabled: disabled,
        helperText: helperText,
        highlight: isActivatingKnight,
        iconPath: icon,
        onClickActionIfDisabled: triggerFlickerCardsAnimation,
        tooltipCustomMenuComponent: /*#__PURE__*/ React.createElement(UIGameResourceCardsTooltipContent, {
            cardInventory: playerValidator.resourceCards.cards,
            cardsToBuild: cardToActivateKnight,
            ref: tooltipRef
        }),
        onClick: onClick
    }));
};
